module.exports = __webpack_public_path__ + "static/media/banner-about.f2c01432.jpg";